(() => {
  const init = () => {
    document.querySelectorAll('[data-pu-finder]').forEach(async form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const [brand,model,type] = form.querySelectorAll('select');
      const options = (el,values,label) => { el.replaceChildren(new Option(label,'')); values.forEach(v=>el.add(new Option(v,v))); };
      try {
        const response = await fetch(form.dataset.source); if (!response.ok) throw new Error('catalogue');
        const data = await response.json();
        options(brand,Object.keys(data),'Toutes les marques');
        const refreshTypes = () => {
          const item = data[brand.value];
          const values = item ? (model.value ? item.models[model.value] : item.types) : Object.values(data).flatMap(d=>d.types);
          options(type,[...new Set(values || [])].sort((a,b)=>a.localeCompare(b,'fr')),'Toutes les pièces');
        };
        brand.addEventListener('change',()=>{ options(model,Object.keys(data[brand.value]?.models || {}),'Tous les modèles');model.disabled=!brand.value; refreshTypes(); });
        model.addEventListener('change',refreshTypes);refreshTypes();
        form.addEventListener('submit',()=>{form.querySelectorAll('select').forEach(s=>{if(!s.value)s.disabled=true;});});
      } catch (_) { brand.disabled=true;model.disabled=true;type.disabled=true; }
    });
    const updateProgress = cart => {
      document.querySelectorAll('[data-pu-cart-progress]').forEach(box=>{
        const remaining=Math.max(0,4900-cart.total_price);
        box.querySelector('progress').value=Math.min(cart.total_price,4900);
        box.querySelector('[data-pu-progress-text]').textContent=remaining ? `Plus que ${new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(remaining/100)} pour la livraison Mondial Relay offerte en France.`:'Seuil de livraison Mondial Relay offerte en France atteint.';
      });
    };
    // The theme updates the subtotal after every AJAX cart change.
    let timer;
    const totals=document.querySelectorAll('[data-cart-total]');
    if(totals.length){const observer=new MutationObserver(()=>{clearTimeout(timer);timer=setTimeout(async()=>{try{const r=await fetch((window.Shopify?.routes?.root||'/')+'cart.js');if(r.ok)updateProgress(await r.json());}catch(_){}},150);});totals.forEach(e=>observer.observe(e,{subtree:true,childList:true,characterData:true}));}
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
